// extracted by mini-css-extract-plugin
export default {"upload-rules":"styles_upload-rules__dOO1b","agreements-form":"styles_agreements-form__xsDSz","form-item":"styles_form-item__9JFCQ","label":"styles_label__oS0hV"};